module.exports = __webpack_public_path__ + "static/fix-statement-738b35cd6131e896f56575bfc1cd0eb1.png";